<template>
    <div class="bg-red-900 bg-opacity-25 h-10 w-full flex items-center p-1 adminpanelmenu relative">
        <ul class="flex items-center gap-1">
            <li v-for="item in items" class="flex items-center">
                <button :class="buttonBg(item.slug)" class="p-1 text-white rounded-md text-xs uppercase"
                    @click.prevent="click(item.slug)" v-text="item.name" />
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'AdminPanelMenu',
    props: ['active'],
    data() {
        return {
            selected: 'stats',
            items: [
                {
                    slug: 'stats',
                    name: 'Stats',
                },
                {
                    slug: 'balances',
                    name: 'Balances',
                },
                {
                    slug: 'users',
                    name: 'Users',
                },
                {
                    slug: 'bots',
                    name: 'Bots',
                },
                {
                    slug: 'sponsors',
                    name: 'Sponsors',
                },
                {
                    slug: 'tickets',
                    name: 'Tickets',
                },
            ],
        }
    },
    methods: {
        click(slug) {
            this.selected = slug
            this.$emit('admin-button-click', this.selected)
        },
        buttonBg(slug) {
            return this.active === slug ? 'bg-red-400 font-semibold' : 'bg-red-500'
        }
    }
}
</script>
